<script>
    export default {
        props: {
            threshold: {
                type: Number,
                default: 0,
            },
            fixedHeader: {
                type: Boolean,
                default: false,
            }
        },
        mounted () {
            if (this.fixedHeader) {
                this.initialize();
            }
        },
        methods: {
            getTarget() {
                if (navigator.userAgent.includes('Edge')) {
                    return 'body';
                }

                return 'html';
            },
            initialize() {
                let $ = (e) => document.querySelector(e);
                let tag = this.getTarget();

                window.addEventListener('scroll', () => {
                    this.isFixed = $(tag).scrollTop > this.threshold
                });
            }
        },
        data () {
            return {
                isFixed: false,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/src/components/Header/Wrapper.vue